var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"absolute top-full w-max rounded-sm drop-shadow-sm text-sm bg-light p-2 text-center transition-all",class:{
      'left-0': _vm.alignment == 'start',
      'right-0': _vm.alignment == 'end',
      'right-2/4 translate-x-1/2': _vm.alignment == 'center',
    },on:{"mouseleave":_vm.close}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }